import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {
  paymentMethods,
  paymentMethodsWithVisualizationSupport,
} from "~/constants/paymentMethods";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Amex } from "~/theme/icons/components/amex";
import { ApplePay } from "~/theme/icons/components/apple-pay";
import { GooglePay } from "~/theme/icons/components/google-pay";
import { Maestro } from "~/theme/icons/components/maestro";
import { MasterCard } from "~/theme/icons/components/master-card";
import { Visa } from "~/theme/icons/components/visa";

import { PAYMENT_METHOD_CLASSES } from "./constants";
import { PaymentMethodContainer } from "./styled";
import { PaymentMethodProps } from "./types";

export const PaymentMethod: React.FC<PaymentMethodProps> = (data) => {
  const { type = "" } = data;

  if (!paymentMethodsWithVisualizationSupport[type]) {
    return null;
  }

  return (
    <PaymentMethodContainer {...getTestAutomationProps("payment-method")}>
      {(type === paymentMethods.AMERICANEXPRESS || type === paymentMethods.AMEX) && (
        <Amex
          title={
            type === paymentMethods.AMERICANEXPRESS ? "american express" : "amex"
          }
        />
      )}
      {type === paymentMethods.VISA && <Visa title="visa" />}
      {type === paymentMethods.MASTERCARD && <MasterCard title="master card" />}
      {type === paymentMethods.MAESTRO && <Maestro title="maestro" />}
      {type === paymentMethods.APPLEPAY && <ApplePay title="apple pay" />}
      {type === paymentMethods.ANDROIDPAY && <GooglePay title="google pay" />}
      {type === paymentMethods.ONE4ALL_VOUCHER && (
        <img
          src="/assets/images/store-details/we-accept/one-4-all.png"
          alt="one4all giftcard"
          className={PAYMENT_METHOD_CLASSES.image}
        />
      )}
      {type === paymentMethods.ME2YOU_VOUCHER && (
        <img
          src="/assets/images/store-details/we-accept/me-2-you.png"
          alt="me2you giftcard"
          className={PAYMENT_METHOD_CLASSES.image}
        />
      )}
      {type === paymentMethods.CASH && (
        <Typography variant="body1">
          <Box component="strong">Cash</Box>
        </Typography>
      )}
    </PaymentMethodContainer>
  );
};
